<template>
<div class="container">

    <div class="hp_map_chart_widget">
        <h3>
            <span>
                <span class="letter">R</span>eal <span class="letter">C</span>lear <span class="letter">P</span>olitics <span class="letter">E</span>lection <span class="year">2020</span>
            </span>
        </h3>
        <div class="map_chart_content">
            <div v-for="election_type in election_types" :class="['section', 'electoral_map', election_type.basename]">
            
                <div v-if="loading" class="e2018_spinner">
                    <div>
                        <div></div>
                    </div>
                </div>

                <div class="score_line">
                    <div class="title">
                        <a :href="election_type.link" v-html="election_type.name"></a>
                    </div>
                    <div class="scores" v-if="election_type.basename == 'president'" >
                        <span style="font-size:12px;" class="dem">
                            <a :href="election_type.link" v-html="electoral_summary.Biden + ' Joe Biden'"></a>
                        </span>
                        <span style="font-size:12px;" class="gop">
                            <a :href="election_type.link" v-html="'Donald Trump '+ electoral_summary.Trump"></a>
                        </span>
                    </div>
                    <div class="scores" v-if="election_type.basename !== 'president'" >
                        <span class="dem">
                            <a :href="election_type.link" v-html="won_seats[election_type.basename].dem + (election_type.basename == 'senate' ? '*' : '') + net_display(net_seats[election_type.basename].dem)+' Dem'"></a>
                        </span>
                        <span class="gop">
                            <a :href="election_type.link" v-html="'GOP '+won_seats[election_type.basename].gop + net_display(net_seats[election_type.basename].gop)"></a>
                        </span>
                    </div>
                </div>
                <div class="map">
                    <a :href="election_type.link">
                        <img :src="img_map[election_type.basename]" :alt="election_type.name+' Live Results 20108'" />
                    </a>
                    <span class="map_ut">
                        <a :href="election_type.link" v-html="election_type.footer_txt"></a>
                    </span>
                </div>
            </div>

        </div>
    </div>

</div>
</template>

<script>

import {rcp_refresh_interval, E2020_PUB_PATH} from './ElectionCommonVars.js';
import ElectionNightMixin from './ElectionNightMixin.js';

export default {
    name: '',
    mixins: [
        ElectionNightMixin,
    ],
    data : function() {
        return {
            "loading_interval" : 0,
            "loading" : true,
            "first_load_done" : false,
            "president_summary" : {},
            "electoral_summary" : {
                "Biden" : 0,
                "Trump" : 0,
            },
            "img_map" : {
                "president" : "",
                "senate" : "",
                "house" : "",
                "governor" : ""
            },
            "election_types" : [
                {
                    "name" : "President",
                    "basename" : "president",
                    "link" : E2020_PUB_PATH+'/president/',
                    "footer_txt" : "All President Results"
                },
                {
                    "name" : "Senate",
                    "basename" : "senate",
                    "link" : E2020_PUB_PATH+'/senate/',
                    "footer_txt" : "All Senate Results"
                },
                {
                    "name" : "House",
                    "basename" : "house",
                    "link" : E2020_PUB_PATH+'/house/',
                    "footer_txt" : "All House Results"
                },
                // {
                //   "name" : "Governors",
                //   "basename" : "governor",
                //   "link" : E2020_PUB_PATH+'/governor/',
                //   "footer_txt" : "All Governor Results"
                // }
            ],
            "won_seats": {
                "president": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                },
                "senate": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                },
                "governor": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                },
                "house": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                }
            },
            "net_seats": {
                "president": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                },
                "senate": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                },
                "governor": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                },
                "house": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                }
            }
        };
    },
    created : function() {

        this.get_data_for_alpha_3();

        // Start refresh cron
        this.loading_interval = setInterval(() => {
            this.fetch_data();
        }, rcp_refresh_interval * 1000);
    },
    methods: {

        fetch_data : function() {

            if(!this.loading) {
                this.get_data_for_alpha_3();
            }
        },

        get_data_for_alpha_3 : function() {

            this.loading = true;
            // Retrieve live results data
            this.rcp_hp_fetch_data((response) => {

                // Successfully retrieved data

                this.won_seats = response.data.won_seats;
                this.net_seats = response.data.net_seats;
                this.president_summary = response.data.president_summary;
                this.electoral_summary = response.data.electoral_summary;

                this.img_map['president'] = E2020_PUB_PATH+"/live_map_president_thumb.png?cache_bust="+this.rcp_cache_bust();
                this.img_map['senate'] = E2020_PUB_PATH+"/live_map_senate_thumb.png?cache_bust="+this.rcp_cache_bust();
                this.img_map['house'] = E2020_PUB_PATH+"/live_map_house_thumb.png?cache_bust="+this.rcp_cache_bust();
                this.img_map['governor'] = E2020_PUB_PATH+"/live_map_governor_thumb.png?cache_bust="+this.rcp_cache_bust();

                this.first_load_done = true;
                this.loading = false;
            });
        },
  },
}
</script>

<style lang="scss">

</style>